import { apiClient } from './client'
import type { ChartData, ChartType, ProgressOverview, StreakInfo } from '@/types/statistics'

export const statisticsApi = {
  getOverview: (): Promise<ProgressOverview> =>
    apiClient.get<ProgressOverview>('/statistics/overview').then((r) => r.data),

  getChartData: (type: ChartType, days: number): Promise<ChartData> =>
    apiClient
      .get<ChartData>('/statistics/charts', { params: { type, days } })
      .then((r) => r.data),

  getStreakInfo: (): Promise<StreakInfo> =>
    apiClient.get<StreakInfo>('/statistics/streak').then((r) => r.data),
}
